var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 62V14.7919C15 7.72589 21.3556 2.30457 28.4444 2.30457L59.7089 2C59.7089 2 70 2.30457 70 14.4873H40.6667C40.6667 12.0508 40.6667 2.30457 28.4444 2.30457",
    stroke: "url(#paint0_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14.7695C60 15.0005 60 57.0063 60 57.2373C60 60.6223 58.6633 63.8687 56.2839 66.2622C53.9046 68.6558 50.6774 70.0005 47.3125 70.0005L14.6875 69.9154C11.3226 69.9154 8.09545 68.5707 5.71608 66.1771C3.33671 63.7836 2 60.5372 2 57.1522C2 56.9212 2 56.6903 2 56.4593H14.6875",
    stroke: "url(#paint1_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0329 39.9488L28.4058 40.0175L28.0221 39.9746C27.1523 39.8771 26.471 39.4847 25.9686 38.8022C25.9677 38.8011 25.9669 38.8 25.9661 38.7988C26.4588 39.2293 27.0587 39.5243 27.712 39.6402L28.1178 39.7122V39.8212L28.4469 39.7706L28.8866 39.8486V39.7029L29.2698 39.6439C30.0492 39.524 30.7545 39.1374 31.2856 38.5627C31.2381 38.6369 31.1885 38.7079 31.1372 38.7757C30.6371 39.4366 29.928 39.8506 29.0329 39.9488ZM30.8816 23.8031C30.957 23.8989 31.0302 24.0036 31.1006 24.1177C30.6387 23.6347 30.0577 23.2798 29.4095 23.0998L28.9107 22.9613V22.7546L29.0139 22.7679C29.7705 22.8656 30.3986 23.189 30.8816 23.8031ZM28.7318 22.7315L28.4489 22.8331L28.1419 22.7478V22.9433L27.5727 23.1478C26.9606 23.3676 26.4226 23.747 26.0035 24.2396C26.5144 23.387 27.2623 22.8771 28.0852 22.752L28.455 22.6957L28.7318 22.7315ZM25.8853 29.6072C25.8763 29.5925 25.8673 29.5777 25.8585 29.5629C26.2728 30.0965 26.8265 30.5056 27.4632 30.7335L28.9107 31.5008V31.2834L29.3137 31.4446L29.3343 31.4529L29.3553 31.4602C30.1476 31.737 30.8425 32.2874 31.3239 33.0377C30.8857 32.523 30.3184 32.1339 29.6751 31.921L29.538 31.8576L28.1178 31.1999V31.2816L27.7536 31.1348L27.7363 31.1278L27.7188 31.1215C26.9758 30.8536 26.3269 30.325 25.8853 29.6072L25.0336 30.1312L25.8853 29.6072Z",
    stroke: "url(#paint2_linear_1370_26296)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24H51",
    stroke: "url(#paint3_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32H51",
    stroke: "url(#paint4_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41 41H51",
    stroke: "url(#paint5_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49H52",
    stroke: "url(#paint6_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57H52",
    stroke: "url(#paint7_linear_1370_26296)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1370_26296",
    x1: 22.9054,
    y1: 4.57763,
    x2: 58.2176,
    y2: 41.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1370_26296",
    x1: 10.3366,
    y1: 17.1423,
    x2: 42.3574,
    y2: 55.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1370_26296",
    x1: 25.2936,
    y1: 20.9881,
    x2: 35.3698,
    y2: 25.4792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1370_26296",
    x1: 42.4373,
    y1: 24.043,
    x2: 42.54,
    y2: 25.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1370_26296",
    x1: 42.4373,
    y1: 32.043,
    x2: 42.54,
    y2: 33.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1370_26296",
    x1: 42.4373,
    y1: 41.043,
    x2: 42.54,
    y2: 42.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1370_26296",
    x1: 28.8808,
    y1: 49.043,
    x2: 28.9191,
    y2: 50.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1370_26296",
    x1: 28.8808,
    y1: 57.043,
    x2: 28.9191,
    y2: 58.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillReceipt);
export default __webpack_public_path__ + "static/media/bill-receipt.f39a5814.svg";
export { ForwardRef as ReactComponent };